module.exports = __webpack_public_path__ + "img/s.c064239a.jpg";